var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"no-order-selected"}},[_c('h2',[_vm._v("No Order Selected")]),_c('p',[_vm._v("Select an order or "),_c('b-button',{attrs:{"variant":"link","disabled":_vm.busy},on:{"click":_vm.new_order}},[_vm._v("create a new order")]),_vm._v(".")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }